/*
全体をクリック不可のロード表示にする
フォームの送信ボタン連打による多重送信防止など

window.pageLoading('on') // ページをローディング表示にする
window.pageLoading('off') // ページのローディング表示を消す
*/
window.pageLoading = function (type = 'on') {
  if (type === 'on') {
    const cover = document.createElement('div')

    cover.className = 'js-pageLoadingView mdLoading active' // ローディングモジュールのクラスを当てる

    // 画面全体を覆う
    const css = `
    position: fixed;
    background: rgba(255,255,255,0.5);
    width: 100%;
    height: 100%;
    max-height: 100%;
    top: 0;
    left: 0;
    z-index: 1000000;
    `
    cover.setAttribute('style', css)

    document.body.appendChild(cover) // 最後の子要素として追加
  } else {
    const item = document.querySelector('.js-pageLoadingView')
    if (item) {
      item.parentNode.removeChild(item)
    }
  }
}

//   ####  ##      ##   ####  ##  ##
//  ##     ##      ##  ##     ## ##
//  ##     ##      ##  ##     ####
//  ##     ##      ##  ##     ## ##
//   ####  ######  ##   ####  ##  ##
/*
クリックで作動させる
<button type="button" class="js-pageLoading">
    ローディング
</button>
*/
if (document.getElementsByClassName('js-pageLoading')[0]) {
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-pageLoading')
    if (!item) {
      return
    }
    window.pageLoading('on') // ページをローディング表示にする
  })
}
